// extracted by mini-css-extract-plugin
export default {"guide-layout":"GuidePage__guide-layout__RN8BW","guideLayout":"GuidePage__guide-layout__RN8BW"};